import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function SlidersIndex({ section }) {
  function updateClassBasedOnScreenSize() {
    const element_1 = document.querySelector(".popular-state");
    if (!element_1) return; // Exit if element_1 is not found

    if (window.innerWidth >= 1024) {
      element_1.classList.add("mb-5");
       
    } else {
      element_1.classList.remove("mb-5"); 
    
    }
}

// Run on page load and when resizing
window.addEventListener("load", updateClassBasedOnScreenSize);
window.addEventListener("resize", updateClassBasedOnScreenSize);


  const [isScrolled, setIsScrolled] = useState(false);
  
    const isSlider = section?.is_slider ?? true;
    const itemsPerView = parseInt(section?.items_per_view) || 4;

    const settings = {
      slidesToShow: itemsPerView, 
      slidesToScroll: 1, 
      autoplay: true,
      autoplaySpeed: 5000, 
      arrows: false, 
      dots: false,
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: { slidesToShow: Math.min(itemsPerView, 5) },
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: 2 },
        },
        {
          breakpoint: 520,
          settings: { slidesToShow: 2 },
        },
      ],
    };
  
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 50);
    };
  
    useEffect(() => {
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  
  
  
      const sliderRef = useRef(null);
    
      const play = () => {
        sliderRef.current.slickPlay();
      };
      const pause = () => {
        sliderRef.current.slickPause();
      };

  const fallbackItems = [
    { image_url: 'assets/img/hotels/1.png', description: 'Get flat 10% OFF* on ride with outstation one way or round trip cab bookings', subtitle: 'Valid till: 30th Nov, 2024' },
    { image_url: 'assets/img/hotels/2.png', description: 'Get flat 10% OFF* on ride with outstation one way or round trip cab bookings', subtitle: 'Valid till: 30th Nov, 2024' },
    { image_url: 'assets/img/hotels/3.png', description: 'Get flat 10% OFF* on ride with outstation one way or round trip cab bookings', subtitle: 'Valid till: 30th Nov, 2024' },
    { image_url: 'assets/img/hotels/4.png', description: 'Get flat 10% OFF* on ride with outstation one way or round trip cab bookings', subtitle: 'Valid till: 30th Nov, 2024' },
    { image_url: 'assets/img/hotels/6.png', description: 'Get flat 10% OFF* on ride with outstation one way or round trip cab bookings', subtitle: 'Valid till: 30th Nov, 2024' },
    { image_url: 'assets/img/hotels/7.png', description: 'Get flat 10% OFF* on ride with outstation one way or round trip cab bookings', subtitle: 'Valid till: 30th Nov, 2024' },
  ];
  const items = section?.Items?.length ? section.Items : fallbackItems;

  return (
    <div>
      <div className="container offers exclusive-officer-sec pb-3">
        <div className="popular-state pb-0 pt-0">
          <div className="container">
            <div className="title text-center ">
              <h3 className="pb-0">{section?.title_highlight ? <span>{section.title_highlight} </span> : <span>Unlock Exclusive </span>}{section?.title || 'Deals and Savings'}</h3>
            </div>
          </div>
        </div>

        <div className={`customer-logos slides-wrapper ${isSlider ? 'slider' : ''} ${ isScrolled && isSlider ? "slider" : ""}`}>
        {isSlider ? (
          <Slider ref={sliderRef} {...settings}>
              {items.map((item, index) => (
                <div className="exclusive-offers-img-sec" key={`${item.image_url}-${index}`}>
                  <img src={item.image_url} alt={item.title || 'Offer'} />
                  <div className="_offrdtl">{item.description || item.title}</div>
                  <div className="_offrdate">{item.subtitle || item.badge_text}</div>
                </div>
              ))}
          </Slider>
        ) : (
          <div className="row">
            {items.map((item, index) => {
              const colWidth = itemsPerView > 0 ? (100 / itemsPerView) : 25;
              return (
                <div 
                  key={`${item.image_url}-${index}`} 
                  className="mb-4"
                  style={{ flex: `0 0 ${colWidth}%`, maxWidth: `${colWidth}%`, padding: '0 15px' }}
                >
                  <div className="exclusive-offers-img-sec mx-auto w-100 h-100">
                    <img src={item.image_url} alt={item.title || 'Offer'} className="w-100" />
                    <div className="_offrdtl">{item.description || item.title}</div>
                    <div className="_offrdate">{item.subtitle || item.badge_text}</div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        </div>
      </div>
    </div>
  );
}

export default SlidersIndex;
